import type { PatientsSearchT } from "@/routes/_app/patients";
import { useAuth } from "@/utils/auth";
import { useSuspenseQuery } from "@tanstack/react-query";
import {
	countBySettingsQueryOptions,
	diariesByPatientQueryOptions,
	diariesBySettingsQueryOptions,
	diariesTabsQueryOptions,
	diaryByIdQueryOptions,
} from "./diaryQueryOptions";

export const useDiaryByIdQuery = (diaryId: string) => {
	return useSuspenseQuery(diaryByIdQueryOptions(diaryId));
};

export const useDiariesByPatientQuery = (patientId: string) => {
	return useSuspenseQuery(diariesByPatientQueryOptions(patientId));
};

export const useDiariesBySettingsQuery = (settings: PatientsSearchT) => {
	const auth = useAuth();
	return useSuspenseQuery(diariesBySettingsQueryOptions(settings, auth));
};

export const useDiariesTabsQuery = (filters: Record<string, unknown> = {}) => {
	return useSuspenseQuery(diariesTabsQueryOptions(filters));
};

export const useCountBySettingsQuery = (settings: PatientsSearchT) => {
	const auth = useAuth();
	return useSuspenseQuery(countBySettingsQueryOptions(settings, auth));
};
